import './Input.scss';

import {
  type InputHTMLAttributes,
  type DetailedHTMLProps,
  PureComponent,
} from 'react';
import { omit } from 'lodash-es';
import classNames from 'classnames';

type HTMLInputElementProps = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

export interface Props extends Omit<HTMLInputElementProps, 'ref'> {
  fullWidth?: boolean;
  invalid?: boolean;
  testID?: string;
}

class Input extends PureComponent<Props> {
  static defaultProps = {
    type: 'text',
    required: false,
    invalid: false,
    fullWidth: true,
  };

  node?: HTMLInputElement | null;

  focus() {
    if (this.node != null) {
      this.node.focus();
    }
  }

  render() {
    return (
      <input
        ref={(node) => (this.node = node)}
        className={classNames(
          'Input',
          {
            'Input--fullWidth': this.props.fullWidth,
            'is-invalid': this.props.invalid,
          },
          this.props.className,
        )}
        data-test-id={this.props.testID}
        {...omit(this.props, ['className', 'invalid', 'fullWidth', 'testID'])}
      />
    );
  }
}

export default Input;
